<template>
<section>

	<div class="count-wrap">
		<div class="count-inner">
			<div class="count-text">运动消耗热量</div>
			<countTo
				class="count-num" 
				:separator='theseparator' 
				:startVal='startVal' 
				:endVal='endVal' 
				:duration='2000'
			>
			</countTo>
			<div class="count-text">卡路里</div>
		</div>
	</div>
	<div class="result-wrap text-center">
		<div class="result-thumb">
			<img v-if="cover" :src="cover">
		</div>
		<div class="result-text">至少需运动时长</div>
		<div class="result-time">
			<div class="times" v-if="hour"><span>{{hour}}</span>小时</div>
			<div class="times" v-if="min"><span>{{min}}</span>分钟</div>
		</div>
	</div>

	<div class="calculate-link" @click="gohome()">返回首页</div>
</section>
</template>

<script>
  import countTo from 'vue-count-to';
  export default {
    components: { countTo },
    data () {
      return {
        startVal: 0,
        endVal: 0,
        theseparator:'',
        hour:0,
        min:0,
        cover:''
      }
    },
    head: {
		title: function () {
			return {
				inner: this.$route.query.thetitle,
				separator: ' ', 
        		complement: ' '
			}
		}
	},
    created(){
    	this.cover = this.$route.query.sportcover
    	this.endVal = parseInt(this.$route.query.totalenergy)
    	var thetime = parseInt(this.$route.query.totaltime)
    	if(thetime >= 60){
    		if(thetime%60 == 0){
    			this.hour = thetime / 60
    		}else{
    			var theresult = (thetime / 60).toFixed(2)
	    		this.hour = parseInt(theresult)
	    		this.min = parseInt((theresult - this.hour).toFixed(2) * 60)
	    	}
    	}else{
    		this.min = thetime
    	}
    },
    methods:{
    	gohome(){
				this.$router.replace({ path: '/'});
			}
    }
  }
</script>

<style scoped>
.count-wrap{
	margin-top:.4rem;
}
.result-wrap .result-thumb img{
	height: 3rem;
}
</style>


// WEBPACK FOOTER //
// result.vue?2c506d1e